export const aboutIntroduction = [
  "I'm Anurag Kumar, a Mumbai-based Software Engineer specializing in Backend Engineering, Generative AI, and Applied Machine Learning, with 2+ years building intelligent products and enterprise systems.",
  'My work sits at the intersection of software engineering and AI. I build backend services, integrate models, optimize databases, and develop interfaces for practical applications.',
];

export const aboutSections = [
  {
    title: 'What I am building now',
    paragraphs: [
      'At Kyndryl, I collaborate with HR stakeholders and a cross-functional team on an in-house AI-powered Talent Acquisition Platform, currently a proof of concept.',
      'Its four-stage agentic pipeline supports resume parsing, candidate scoring, and verification, using FastAPI, PostgreSQL, and React, with 300+ automated backend tests.',
      'I also operate an ELK observability platform across 11 banking applications, while developing Python and XGBoost pipelines for anomaly detection and time-series forecasting.',
    ],
  },
  {
    title: 'The experience behind it',
    paragraphs: [
      'At Sypha AI, I engineered asynchronous FastAPI middleware, AI integrations, and developer tooling. API orchestration and request-handling improvements reduced latency by 20%.',
      'Microservices and Redis caching doubled load-handling capacity. PostgreSQL query optimization and connection pooling enabled 1.5x faster retrieval.',
      'Earlier at Smartavya Analytica, I engineered multi-model RAG workflows for financial disclosures, improving extraction accuracy on charts, graphs, and tables by 40%.',
      'That work included request routing, result reuse, and 20+ production FastAPI endpoints supporting AI workflows and frontend integration.',
    ],
  },
  {
    title: 'How I approach engineering',
    paragraphs: [
      'I care about system design, performance, testing, and taking ownership throughout the software development lifecycle, from designing APIs to delivering reliable releases.',
      'I have mentored junior developers, contributed to production releases, and worked with cross-functional teams to turn complex requirements into practical solutions.',
      'I am an AWS Certified AI Practitioner and an IIIT Kottayam graduate. I am motivated by AI-native products built with reliability, scalability, and engineering discipline.',
    ],
  },
];
